import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useHistory } from "react-router-dom/cjs/react-router-dom.js";
import { message } from "antd";
import bgLogin from "../../assets/bgLogin.png";
import { resetarSenha } from "../../services/api";
import "./styles.css";

export default function EsqueciMinhaSenha() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(true);
  const [errors, setErrors] = useState({});
  const history = useHistory();

  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const validateForm = () => {
    const newErrors = {};

    if (!email.trim()) {
      newErrors.email = "E-mail é obrigatório";
    } else if (!validateEmail(email)) {
      newErrors.email = "E-mail inválido";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) {
      message.error("Por favor, corrija os erros no formulário");
      return;
    }

    setLoading(true);

    try {
      const response = await resetarSenha(email);

      if (response.fail) {
        if (response.errors && response.errors.length > 0) {
          message.error(
            response.errors[0].message ||
              "Erro ao enviar solicitação de recuperação de senha"
          );
        } else {
          message.error("Erro ao enviar solicitação de recuperação de senha");
        }
      } else {
        message.success(
          "Solicitação de recuperação de senha enviada com sucesso! Verifique seu e-mail."
        );
        // Redirecionar para a página de login após sucesso
        setTimeout(() => {
          history.push("/");
        }, 200);
      }
    } catch (error) {
      console.error("Erro na recuperação de senha:", error);
      message.error("Erro ao processar solicitação. Tente novamente.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-content">
        <h2>Recuperar senha</h2>
        <hr
          style={{
            width: "40px",
            margin: "16px 0",
            border: "1.5px solid #979797",
          }}
        />
        <p>Informe seu e-mail para recuperar sua senha</p>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="email">E-mail</label>
            <input
              type="email"
              id="email"
              name="email"
              placeholder="Seu e-mail cadastrado"
              autoComplete="email"
              value={email}
              onChange={(e) => {
                setEmail(e.target.value);
                if (errors.email) {
                  setErrors({ ...errors, email: "" });
                }
              }}
              className={errors.email ? "error" : ""}
            />
            {errors.email && (
              <span className="error-message">{errors.email}</span>
            )}
          </div>

          <button type="submit" className="btn-login">
            Enviar
          </button>
        </form>

        <div className="d-flex justify-content-between align-items-center">
          <Link
            to="/login"
            style={{ color: "#979797", textDecoration: "none" }}
          >
            Voltar para o login
          </Link>
          <Link
            to="/alterar-senha"
            style={{ color: "#979797", textDecoration: "none" }}
          >
            Já tenho o código
          </Link>
        </div>
      </div>
    </div>
  );
}
